import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { data, Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";
import { apibaseurl } from "../../environment";

const RoboticsProgramPage: React.FC = () => {
  const location = useLocation();
  const trainingId = location?.state?.training?.id;
  const [trainer, setTrainer] = useState<any>([]);
  const [isNominated, setIsNominated] = useState<boolean | null>(null);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [feedbackQuestions, setFeedbackQuestions] = useState<any>([]);
  const [trainingData, setTrainingData] = useState<any>(null);
  const [nominationData, setNominationData] = useState<any>([]);
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [feedbackAnswer, setFeedbackAnswer] = useState<{
    [key: string]: string;
  }>({});
  const [submittedFeedback, setSubmittedFeedback] = useState<{
    [key: string]: string;
  }>({});
  const [showFeedButton, setShowFeedButton] = useState<any>(false);
  const [count, setCount] = useState(1);
  const [assessment, setAssessment] = useState<any>({});
  const [assesmentFormData, setAssesmentFormData] = useState({
    description: "",
    file: null,
  });

  // Custom hook setup
  const {
    data: apiData,
    error: trainingError,
    loading: trainingLoading,
  } = useApi("/api/get-training", {
    method: "POST",
    payload: { training_id: trainingId },
    autoCall: true,
    dependencies: [count],
  });

  const { callApi: AssesmentPostData } = useApi(
    "/api/upload-assessment-employee",
    {
      method: "POST",
      autoCall: false,
    },
  );

  const {
    data: assesmentData,
    error: assesmentDataError,
    loading: assesmentDataLoading,
  } = useApi(`/api/get-assesment/${trainingId}`, {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (assesmentData?.success) {
      setAssessment(assesmentData?.data);
    }
  }, [assesmentData]);

  useEffect(() => {
    if (apiData?.success && Array.isArray(apiData.data)) {
      const trainingObj = apiData.data[0];

      const endDate = apiData?.data[0]?.end_date; // e.g., "2025-09-03"
      const endTime = apiData?.data[0]?.end_time; // e.g., "12:00:00"

      if (endDate && endTime) {
        const fullEndDateTimeString = `${endDate}T${endTime}`;
        const endDateTime = new Date(fullEndDateTimeString);
        const now = new Date();
        if (now >= endDateTime) {
          setShowFeedButton(true);
        }
      }

      setIsNominated(apiData?.isNominated);
      setTrainingData(trainingObj);
      const nominatedReasonsArray = apiData?.nomination?.nominated_reason
        ? JSON.parse(apiData.nomination.nominated_reason)
        : [];

      setNominationData(nominatedReasonsArray);
      setTrainer(trainingObj?.trainers || []);
    }
  }, [apiData, trainingData]);

  const reasons = [
    { id: "improveSkills", label: "Improve my technical skills" },
    { id: "careerGrowth", label: "Enhance career growth opportunities" },
    {
      id: "projectSupport",
      label: "Gain knowledge for current or future projects",
    },
    { id: "networking", label: "Network and collaborate with peers" },
    { id: "personalInterest", label: "Personal interest in the subject" },
    { id: "otherReason", label: "Other" },
  ];

  const {
    data: nominatedData,
    error: nominatedError,
    loading: nominatedLoading,
    callApi: submitNomination,
  } = useApi("/api/add-nomination", {
    method: "POST",
    autoCall: false,
  });

  const handleCheckboxChange = (id: string, label: string) => {
    setSelectedReasons((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label],
    );
  };

  const handleSubmit = async () => {
    if (selectedReasons.length === 0) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select at least one reason for joining the training.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    const payload = {
      training_id: trainingId,
      nominated_reason: JSON.stringify(selectedReasons),
    };
    try {
      const response = await submitNomination(payload);
      if (response?.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "Nominated successfully 🎉",
          icon: "success",
          confirmButtonText: "OK",
        });
        setSelectedReasons([]);
        setCount(count + 1);
      } else {
        Swal.fire({
          title: "Oops!",
          text: response.message || "Something went wrong.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      if (error) {
        Swal.fire({
          title: "Error!",
          text:
            error?.response?.data?.message ||
            "Failed to nominate. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  useEffect(() => {}, [nominatedData, nominatedError]);

  // API Hook
  // Feedback Questins
  const {
    data: feedBackQuestion,
    error: feedbackError,
    loading: feedbackLoading,
  } = useApi("/api/get-feedback-question", {
    method: "GET",
    autoCall: true,
  });
  useEffect(() => {
    if (feedBackQuestion?.success) {
      setFeedbackQuestions(feedBackQuestion?.data);
    }
  }, [feedbackQuestions, selectedId]);

  // submit feedback
  const {
    data: feedbackData,
    error: feedbackDataError,
    loading: feedbackDataLoading,
    callApi: submitFeedback,
  } = useApi("/api/submit-feedback", {
    method: "POST",
    autoCall: false,
  });

  const handler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFeedbackAnswer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit feedback
  const SubmitAnswer = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      const training_id = trainingId;
      const feedbackRecord = Object.entries(feedbackAnswer).map(
        ([key, value]) => {
          const question = parseInt(key.replace("q", ""), 10); // Convert 'q1' → 1
          return { question, ans: value };
        },
      );
      const payload = {
        training_id,
        feedbackRecord,
      };
      const response = await submitFeedback(payload);
      if (response?.success) {
        Swal.fire({
          title: "Success!",
          text: response.message || "Feedback submitted successfully 🎉",
          icon: "success",
          confirmButtonText: "OK",
        });
        setSubmittedFeedback(feedbackAnswer);
        setFeedbackAnswer({});
      } else {
        Swal.fire({
          title: "Error!",
          text: response.message || "Something went wrong.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.error("❌ Feedback submission error:", error);
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting feedback.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  useEffect(() => {
    const modal = document.getElementById("feedbackModal");

    const handleModalShow = () => {
      if (Object.keys(submittedFeedback).length > 0) {
        setFeedbackAnswer(submittedFeedback);
      }
    };

    modal?.addEventListener("shown.bs.modal", handleModalShow);

    return () => {
      modal?.removeEventListener("shown.bs.modal", handleModalShow);
    };
  }, [submittedFeedback]);

  const getAssesmentInputData = (e: any) => {
    const { name, value, files } = e.target;
    console.log(name);
    if (name === "file") {
      setAssesmentFormData({ ...assesmentFormData, [name]: files[0] });
    } else {
      setAssesmentFormData({ ...assesmentFormData, [name]: value });
    }
  };

  const postAssesmentData = async (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("description", assesmentFormData.description);
    formData.append("training_id", trainingId);
    if (assesmentFormData.file) formData.append("file", assesmentFormData.file);
    try {
      const response = await AssesmentPostData(formData);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.message || "Assessment added successfully.",
          showConfirmButton: true,
        });
      }
      document.getElementById("closed_assesmentModal")?.click();
      setAssesmentFormData({
        description: "",
        file: null,
      });
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        showConfirmButton: true,
      });
    }
  };

  // Helper function
  const isTrainingExpired = (endDate: string, endTime: string) => {
    if (!endDate || !endTime) return false;
    const trainingEnd = new Date(`${endDate}T${endTime}`);
    const now = new Date();
    return trainingEnd < now;
  };

  // Usage
  const expired = isTrainingExpired(
    trainingData?.end_date,
    trainingData?.end_time,
  );

  const formatYMDToLongDate = (dateString: string | null): string => {
    if (!dateString) return "N/A";

    const [year, month, day] = dateString.split("-").map(Number);
    if (!day || !month || !year) return "N/A";

    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">{trainingData?.training_title}</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.employeeDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Training Management</li>
                <li className="breadcrumb-item active" aria-current="page">
                  {trainingData?.training_title}
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="ms-2 head-icons">
              <CollapseHeader />
            </div>
          </div>
        </div>

        {/* Program Details */}
        <div className="row">
          <div className="col-12">
            <div className="card shadow-lg rounded-3 border-0 ">
              <div className="card-body m-4">
                {/* Title + Meta Info */}

                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="mb-2">{trainingData?.training_title}</h1>
                  <div className="d-flex">
                    {!expired && isNominated && (
                      <button
                        className="btn custom_button text-white px-4 me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#feedbackModal"
                        onClick={() => setSelectedId(trainingId)}
                      >
                        Feedback
                      </button>
                    )}

                    {isNominated && (
                      <button
                        className="btn btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#view_assessment"
                      >
                        View Assesment
                      </button>
                    )}
                  </div>
                </div>

                <div className="training-info-card">
                  <div className="row">
                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-calendar-event info-icon calendar"></i>
                        {/* <span><strong>Dates:</strong> 10-Mar-2025 → 14-Mar-2025</span> */}
                        <span>
                          <strong>Dates:</strong>{" "}
                          {formatYMDToLongDate(trainingData?.start_date)} →{" "}
                          {formatYMDToLongDate(trainingData?.end_date)}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-clock info-icon clock"></i>
                        <span>
                          <strong>Time:</strong>{" "}
                          {trainingData?.start_time.slice(0, 5)} –{" "}
                          {trainingData?.end_time.slice(0, 5)}{" "}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-map-pin info-icon venue"></i>
                        <span>
                          <strong>Venue:</strong> {trainingData?.venue}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-map-pin info-icon venue"></i>
                        <span>
                          <strong>Delivery Plan:</strong>{" "}
                          {trainingData?.delivery_plan}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-file-description info-icon pdf"></i>
                        <span>
                          <strong>Learning Outcomes:</strong>{" "}
                          <a
                            href={`${apibaseurl}/${trainingData?.learning_outcome}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                          >
                            View PDF
                          </a>
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6 my-2">
                      <div className="info-row">
                        <i className="ti ti-file-certificate info-icon pdf"></i>
                        <span>
                          <strong>Curriculum:</strong>{" "}
                          <a
                            href={`${apibaseurl}/${trainingData?.curriculum}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                          >
                            View PDF
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row g-4 mt-1">
                  <div className="col-12">
                    <h5 className="card-title fw-bold mb-3">
                      Trainer Information
                    </h5>
                    <div className="card shadow-sm border-0">
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover mb-0">
                            <thead className="table-light">
                              <tr>
                                <th>Trainer Name</th>
                                <th>Gender</th>
                                <th>Expertise Area</th>
                                <th>Experience</th>
                                {/* <th>Resume</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {trainer?.length > 0 ? (
                                trainer.map((record: any, index: any) => (
                                  <tr key={index}>
                                    {/* Trainer Name */}
                                    <td>
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ minWidth: "180px" }}
                                      >
                                        <img
                                          src={
                                            record.profile_picture
                                              ? `${apibaseurl}/${record.profile_picture}`
                                              : "/assets/img/logo/profilepic.jpg"
                                          }
                                          alt={record.full_name}
                                          className="rounded-circle me-2"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            objectFit: "cover",
                                          }}
                                        />
                                        <span className="fs-14 fw-medium">
                                          {record.full_name}
                                        </span>
                                      </div>
                                    </td>

                                    {/* Email */}
                                    <td style={{ minWidth: "100px" }}>
                                      {record.gender}
                                    </td>

                                    {/* Expertise Area */}
                                    <td style={{ minWidth: "180px" }}>
                                      {record.expertise_area}
                                    </td>

                                    {/* Experience */}
                                    <td style={{ minWidth: "100px" }}>
                                      {record.experience} years
                                    </td>

                                    {/* Resume */}
                                    {/* <td>
                                                                            {record.resume_pdf ? (
                                                                                <a
                                                                                    href={`${apibaseurl}/${record.resume_pdf}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="text-info"
                                                                                >
                                                                                    <i className="bi bi-file-pdf me-1"></i> View
                                                                                </a>
                                                                            ) : (
                                                                                <span className="text-muted">N/A</span>
                                                                            )}
                                                                        </td> */}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    className="text-center text-muted py-3"
                                  >
                                    No trainer data available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3 pt-2">
                  <h5 className="fw-bold mb-3">
                    Why do you want to join this training? (Select all that
                    apply)
                  </h5>
                  {isNominated
                    ? reasons.map((reason) => (
                        <div className="form-check my-2" key={reason.id}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={reason.id}
                            checked={nominationData.includes(reason.label)}
                            onChange={() =>
                              handleCheckboxChange(reason.id, reason.label)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={reason.id}
                          >
                            {reason.label}
                          </label>
                        </div>
                      ))
                    : // Render this block if isNominated is false
                      reasons.map((reason) => (
                        <div className="form-check my-2" key={reason.id}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={reason.id}
                            checked={selectedReasons.includes(reason.label)}
                            onChange={() =>
                              handleCheckboxChange(reason.id, reason.label)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={reason.id}
                          >
                            {reason.label}
                          </label>
                        </div>
                      ))}
                  <div className="d-flex justify-content-end gap-1">
                    {!expired && (
                      <button
                        className="btn custom_button text-white px-4"
                        onClick={handleSubmit}
                        disabled={!!isNominated} // convert null | boolean → strictly boolean
                      >
                        {nominatedLoading
                          ? "Submitting..."
                          : isNominated
                            ? "Nominated"
                            : "Nominate"}
                      </button>
                    )}

                    {/* <button
                                            className="btn custom_button text-white px-4"
                                            onClick={handleSubmit}
                                            disabled={isNominated ? true : false}
                                        >
                                            {nominatedLoading
                                                ? "Submitting..."
                                                : isNominated
                                                    ? "Nominated"
                                                    : "Nominate"}
                                        </button> */}

                    {isNominated && (
                      <button
                        className="btn btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#upload_assessment"
                      >
                        Add Assessment File
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="feedbackModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Submit Feedback</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              {/* Q1 */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  1. {feedbackQuestions[0]?.question}
                </label>
                {["Excellent", "Good", "Average", "Poor"].map((option, idx) => (
                  <div className="form-check" key={option}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="q1"
                      value={option}
                      checked={feedbackAnswer.q1 === option}
                      onChange={handler}
                      id={`q1_${idx + 1}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`q1_${idx + 1}`}
                    >
                      {option}
                    </label>
                  </div>
                ))}
              </div>

              {/* Q2 */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  2. {feedbackQuestions[1]?.question}
                </label>
                {["Strongly Agree", "Agree", "Neutral", "Disagree"].map(
                  (option, idx) => (
                    <div className="form-check" key={option}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="q2"
                        value={option}
                        checked={feedbackAnswer.q2 === option}
                        onChange={handler}
                        id={`q2_${idx + 1}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`q2_${idx + 1}`}
                      >
                        {option}
                      </label>
                    </div>
                  ),
                )}
              </div>

              {/* Q3 */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  3. {feedbackQuestions[2]?.question}
                </label>
                <select
                  onChange={handler}
                  className="form-select"
                  name="q3"
                  value={feedbackAnswer.q3 || ""}
                >
                  <option value="">Select an option</option>
                  <option value="highly">Highly Relevant</option>
                  <option value="moderate">Moderately Relevant</option>
                  <option value="low">Slightly Relevant</option>
                  <option value="not">Not Relevant</option>
                </select>
              </div>

              {/* Q4 */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  4. {feedbackQuestions[3]?.question}
                </label>
                <div className="d-flex gap-2">
                  {["Excellent", "Good", "Average", "Poor"].map(
                    (option, idx) => (
                      <div key={option} className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="q4"
                          value={option}
                          checked={feedbackAnswer.q4 === option}
                          onChange={handler}
                          id={`q4_${idx + 1}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`q4_${idx + 1}`}
                        >
                          {option}
                        </label>
                      </div>
                    ),
                  )}
                </div>
              </div>

              {/* Q5 */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  5. {feedbackQuestions[4]?.question}
                </label>
                {["Definitely", "Maybe", "Not Sure", "No"].map(
                  (option, idx) => (
                    <div className="form-check" key={option}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="q5"
                        value={option}
                        checked={feedbackAnswer.q5 === option}
                        onChange={handler}
                        id={`q5_${idx + 1}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`q5_${idx + 1}`}
                      >
                        {option}
                      </label>
                    </div>
                  ),
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                onClick={SubmitAnswer}
                className="btn custom_button btn-primary"
              >
                Submit Feedback
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>

      <div className="modal fade" id="view_assessment">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h4 className="modal-title">
                Assessment Details
                <>
                  <br />
                  <small className="text-muted">
                    {trainingData?.training_title}
                  </small>
                </>
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {assessment ? (
                <div className="p-3 border rounded bg-light">
                  <h5 className="fw-bold mb-3">{assessment.title}</h5>

                  <p className="mb-3">
                    <strong>Description:</strong>
                    <br />
                    {assessment.description}
                  </p>

                  <p>
                    <strong>Assessment Document</strong>
                    <br />
                    {assessment.file ? (
                      <a
                        href={`${apibaseurl}/${assessment.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-primary mt-2"
                        download
                      >
                        View
                      </a>
                    ) : (
                      <span className="text-muted">No document available</span>
                    )}
                  </p>
                </div>
              ) : (
                <div className="text-center py-4">
                  <h5 className="text-muted">No Data Found</h5>
                </div>
              )}

              <div className="d-flex justify-content-end mt-3">
                <button data-bs-dismiss="modal" className="btn btn-secondary">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="upload_assessment">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h4 className="modal-title">
                Add Assessment File
                <>
                  <br />
                  <small className="text-muted">
                    {trainingData?.training_title}
                  </small>
                </>
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closed_assesmentModal"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <form onSubmit={postAssesmentData}>
                <div className="p-3 border rounded bg-light">
                  {/* Description */}
                  <div className="mb-3">
                    <label
                      htmlFor="assessmentDescription"
                      className="form-label"
                    >
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      name="description"
                      id="assessmentDescription"
                      rows={4}
                      placeholder="Enter assessment description"
                      onChange={getAssesmentInputData}
                      value={assesmentFormData.description}
                    ></textarea>
                  </div>

                  {/* File Upload */}
                  <div className="mb-3">
                    <label htmlFor="assessmentFile" className="form-label">
                      Upload File <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      name="file"
                      className="form-control"
                      id="assessmentFile"
                      accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                      onChange={getAssesmentInputData}
                    />
                  </div>
                </div>

                {/* Footer */}
                <div className="d-flex justify-content-end mt-3">
                  <button type="submit" className="btn btn-primary">
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RoboticsProgramPage;
